import axios from 'axios';
import store from '../store';
import router from '../router';
import * as Sentry from '@sentry/browser';

const config = {
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/ld+json',
  },
};

const instance = axios.create(config);
instance.interceptors.response.use(null, error => handleCommonApiErrors(error));

/**
 *
 * @param {string} jwt
 */
export function apiSetJwt(jwt) {
  instance.defaults.headers.common = { Authorization: `Bearer ${jwt}` };
}

/**
 *
 * @param {string} language
 */
export function apiSetLanguage(language) {
  instance.defaults.headers.common = { 'Accept-Language': language };
}

export const api = instance;

export const DocumentAxiosConfig = {
  responseType: 'arraybuffer',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/pdf',
  },
};

export function handleCommonApiErrors(error) {
  const { dispatch } = store;

  if (error.response.status === 401) {
    dispatch('user/logout');

    router.push({ name: 'login' });
    return Promise.reject(error);
  }

  if (error.response.status === 404) {
    dispatch('app/setToaster', [
      {
        error: 'errors.missing_page',
        time: Date.now(),
      },
    ]);

    router.push({ name: 'home' });

    Sentry.captureException(error);
    return Promise.reject(error);
  }

  if (
    error.response.status === 400 ||
    error.response.status === 403 ||
    error.response.status === 500
  ) {
    dispatch('app/setToaster', [
      {
        error: 'errors.server_error',
        time: Date.now(),
      },
    ]);

    Sentry.captureException(error);
    return Promise.reject(error);
  }

  Sentry.captureException(error);
  return error;
}
